/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: General = 0, Important = 1, FollowUp = 2, Meeting = 3, Call = 4, Email = 5, Internal = 6, CustomerFacing = 7, Customer = 8, StatusReason = 9
 */
export enum Routemize_Entities_Metadata_NoteType {
    GENERAL = 'General',
    IMPORTANT = 'Important',
    FOLLOW_UP = 'FollowUp',
    MEETING = 'Meeting',
    CALL = 'Call',
    EMAIL = 'Email',
    INTERNAL = 'Internal',
    CUSTOMER_FACING = 'CustomerFacing',
    CUSTOMER = 'Customer',
    STATUS_REASON = 'StatusReason',
}
